/**
 * Created by: cparaschiv
 * Date: 24.10.2013, 13:01
 */

TS.ns('TS.UI');

(function (window, undefined) {
    'use strict';

    var unwrap = TS.unwrap,
        rightAlignedTypes_List = ['Decimal', 'Date', 'DateTime'],
        rightAlignedTypes_Edit = ['date', 'time', 'numeric'],
        checboxCls = 'align-center checkbox-cell',
        iconChecked = 'fa fa-check-square-o',
        iconUnchecked = 'fa fa-square-o';

    var renderRadioCell = function (f, dataRow) {
        var ret = '',
            currentValue = unwrap(dataRow[f.PropertyName()]);

        $.each(f.records(), function (idx, rec) {
            var item = '',
                checked = '', uid,
                val, txt,
                id, name;
            
            uid = dataRow.uid;
            val = unwrap(rec[f.ValueMember]);
            txt = unwrap(rec[f.ListMember]);

            if (currentValue == val) {
                checked = 'checked';
            }

            name = 'radio-cell-' + uid;
            id = name + '-' + val;

            var disabledString = f.readOnly === true ? 'disabled="true"' : '';

            item += '<input id="' + id + '" name="' + name + '" type="radio" value="' + val + '" ' + checked + ' ' + disabledString + '>';
            item += '<label class="radio-cell-label" for="' + id + '">' + txt + '</label>';

            ret += item;
        });
        return ret;
    };
    
    var renderHyperlinkCell = function (f, dataRow) {
        var urlPropName, link,
            target = '',
            val;

        val = dataRow[f.PropertyName()];
        if (!val) {
            return '';
        }

        urlPropName = f.UrlPropertyName();
        if (urlPropName) {
            link = unwrap(dataRow[urlPropName]);
            if (f.openLinkInPopup()) {
                target = 'target="_blank"';
            }

            return '<a href="' + link + '" ' + target + ' title="' + val + '">' + val + '</a>';
        }

        return val;
    };

    TS.UI.Renderers = {
        list: {
            _default: {
                getCellClass: function (field, dataRow) {
                    if (rightAlignedTypes_List.indexOf(field.DataType()) != -1) {
                        return 'align-right';
                    }
                    if (field.DataType() == 'Boolean') {
                        return checboxCls;
                    }

                    return '';
                },

                getCellContent: function (field, dataRow, isPopup) {
                    var f = field,
                        fmt,
                        fieldType,
                        val,
                        ret,
                        href, cls;

                    val = dataRow[f.FieldName()];
                    fieldType = f.DataType();

                    if (!val && (val != 0) && fieldType != 'Boolean')
                        val = '';

                    fmt = f.Format && f.Format();
                    if (fmt) {
                        if (fieldType == 'Date' || fieldType == 'DateTime') {
                            val = kendo.toString(kendo.parseDate(val), fmt) || '';
                        }
                        else {
                            fmt = '{0:' + fmt + '}'; //TODO: translate format
                            val = kendo.format(fmt, val);
                        }
                    }

                    if (fieldType == 'Boolean') {
                        ret = '<i class=\"' + (!!val ? iconChecked : iconUnchecked) + '\"></i>';
                        return ret;
                    }

                    // CP 2040225 - HTML encode value; strings such as <\/script><script>evil()<\/script> break the rendering
                    val = kendo.htmlEncode(val);
                    if (val === '') {
                        val = '&nbsp';
                    }
                    ret = '<span title=\"' + val + '\">' + val + '</span>';

                    if (f.isEditLink && ts.unwrap(f.isEditLink)) {
                        href = ' href="' + dataRow.editLink + '"';
                        cls = '';

                        // for popups, don't use href='#' attribute values, will cause document to scroll to top
                        if (isPopup) {
                            href = '';
                            cls = ' class="select-link"';
                        }
                        ret = "<a" + href + cls + "title=\"" + val + "\">" + val + "</a>";
                    }

                    return ret;
                },

                getEmptyContent: function () {
                    var s = TS.cultures.current.gridLocalization;
                    return "<div class='grid-empty-content'>" + (s.emptyContent || "Nothing to show") + "</div>";
                }
            }
        },

        grid: {
            _default: {
                getCellClass: function (field, dataRow) {
                    var f = field,
                        dynCfg,
                        cls;

                    if (field.IsDynamicColumn) {
                        dynCfg = TS.widget.gridHelper.getCfg(field, dataRow);
                        if (dynCfg) {
                            f = dynCfg;
                        }
                    }

                    if (rightAlignedTypes_Edit.indexOf(f.type) != -1) {
                        return 'align-right';
                    }

                    if (f.type == 'radiogroup') {
                        return 'radio-cell';
                    }
                    if (f.type == 'bool') {
                        cls = checboxCls;
                        if (f.readOnly === true) {
                            cls += ' checkbox-cell-read-only';
                        }
                        return cls;
                    }
                    return '';
                },

                getHeaderClass: function (f) {
                    if (rightAlignedTypes_Edit.indexOf(f.type) != -1) {
                        return 'align-right';
                    }
                    if (f.type == 'bool') {
                        return 'align-center';
                    }
                    return '';
                },

                getCellContent: function (field, dataRow) {
                    var f = field,
                        prop,
                        fmt,
                        val, str,
                        ret,
                        dynCfg;

                    if (f.type == 'radiogroup') {
                        return renderRadioCell(field, dataRow);
                    } else if (f.type == 'hyperlink') {
                        return renderHyperlinkCell(field, dataRow);
                    }

                    if (field.IsDynamicColumn) {
                        dynCfg = TS.widget.gridHelper.getCfg(field, dataRow);
                        if (dynCfg) {
                            f = dynCfg;
                        }
                    }
                    prop = f.PropertyName();
                    if (f.DisplayPropertyName) {
                        prop = ko.valueOf(f.DisplayPropertyName);
                    }

                    if (prop.indexOf('.') > -1) {
                        val = TS.Util.getProperty(dataRow, prop);
                    }
                    else {
                        val = dataRow[prop];
                    }

                    if (f.type == 'bool') {
                        ret = '<i class=\"' + (!!val ? iconChecked : iconUnchecked) + '\"></i>';
                        return ret;
                    }

                    if (!val && (val != 0))
                        val = '';

                    if (typeof val == 'string') {
                        str = val;
                    } else {
                        str = String(val);
                    }

                    if (f.type == 'numeric') {
                        fmt = TS.Util.kendoNumericFormat(f.decimalPrecision, f.useThousandSeparator);
                        str = kendo.toString(val, fmt);
                    } else {
                        if (f.format) {
                            fmt = f.format;
                            if (f.type == 'date' || f.type == 'dateTime') {
                                if (val != '')
                                    str = kendo.toString(kendo.parseDate(val), fmt);
                                else
                                    str = val;
                            }
                            else
                                str = kendo.toString(val, fmt);
                        }
                    }

                    // CP 2040225 - HTML encode value; strings such as <\/script><script>evil()<\/script> break the rendering
                    str = kendo.htmlEncode(str);
                    ret = '<span title=\"' + str + '\">' + str + '</span>';

                    return ret;
                }
            }
        }
    }
})(this);